export default __webpack_public_path__ + "static/media/tiktok.cafe5a25.svg";